import { render, staticRenderFns } from "./AddBtnCustomizeField.vue?vue&type=template&id=7a158af5&scoped=true"
import script from "./AddBtnCustomizeField.vue?vue&type=script&lang=js"
export * from "./AddBtnCustomizeField.vue?vue&type=script&lang=js"
import style0 from "./AddBtnCustomizeField.vue?vue&type=style&index=0&id=7a158af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a158af5",
  null
  
)

export default component.exports